/* Gestione installazione PWA "su richiesta":
   intercetta e BLOCCA il prompt automatico di Android/Chrome (beforeinstallprompt)
   e lo rende disponibile solo quando l'utente tocca il pulsante "Installa app". */
let deferred = null;
const listeners = new Set();

function notify() {
  listeners.forEach((l) => {
    try { l(!!deferred); } catch (e) {}
  });
}

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault(); // niente banner automatico
    deferred = e;
    notify();
  });
  window.addEventListener("appinstalled", () => {
    deferred = null;
    notify();
  });
}

export function canInstall() {
  return !!deferred;
}

export function onInstallChange(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export async function promptInstall() {
  if (!deferred) return false;
  deferred.prompt();
  const choice = await deferred.userChoice;
  if (choice && choice.outcome === "accepted") {
    deferred = null;
    notify();
    return true;
  }
  return false;
}
